import {ViewPlugin} from '@codemirror/view';

import {decorators} from "./decorators.js";
import {DecorationSet} from './set.js';

export function highlightDecorations() {
  return ViewPlugin.define(view => ({view}), {decorations});
}

function decorations({view}) {
  const set = new DecorationSet();
  for (const range of view.visibleRanges) {
    for (let position = range.from; position <= range.to;) {
      const line = view.state.doc.lineAt(position);
      iterate(view.state, line, set);
      position = line.to + 1;
    }
  }
  return set.decorationsAsArray();
}

function iterate(state, {from, to}, set) {
  state.tree.iterate({
    from, to,
    enter(type) {
      const start = type.from;
      const end = type.to;
      return eachDecorator({
        type: type.name,
        word: {start, end},
        set,
        line: {from, to}
      });
    }
  });
}

function eachDecorator({type, word, set, line}) {
  for (const decorator of decorators) {
    const _continue = decorator(type, word.start, word.end, set, line);
    if (_continue === false) {
      return false;
    }
  }
}
